import React from 'react';
import { Lock } from 'lucide-react';
import { cn } from '@/shared/lib/utils';
import { useTranslation } from 'react-i18next';
import type { RestrictedIssue } from '@momentum/types';

interface RestrictedGoalCardProps {
  goal: RestrictedIssue;
  level: number;
}

export const RestrictedGoalCard: React.FC<RestrictedGoalCardProps> = ({
  goal: _goal, // Prefix with underscore to indicate intentionally unused (we just need to receive it for the component signature)
  level,
}) => {
  const { t } = useTranslation('goals');

  return (
    <div
      className="w-full transition-all duration-200"
      style={level > 0 ? { marginInlineStart: `${level * 48}px` } : undefined}
    >
      <div
        className={cn(
          'group relative bg-gray-50 rounded-sm border border-gray-200 shadow-sm overflow-hidden',
          'transition-all duration-200 mb-3',
          level === 0 && 'shadow-md'
        )}
      >
        <div className="absolute start-0 inset-y-0 w-1 bg-gray-300" />

        <div className="p-5 ps-4 relative opacity-60">
          <div className="flex items-start justify-between gap-4">
            <div className="flex items-start gap-2">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <Lock className="h-4 w-4 text-gray-400" />
                  <h3 className="text-sm font-medium text-gray-500">
                    {t('restrictedGoal.title')}
                  </h3>
                </div>
                <p className="text-xs text-gray-400 mt-1">
                  {t('restrictedGoal.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
